export default  function fadeInElement(dom, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ opacity: "0" }, { opacity: "1" }], {
        fill: "forwards",
        timingFunction:"ease-in",
        duration: milliseconds
    }
    );



}

export  function pulseElemntBGColor(dom,colorFrom,colorTo, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ background: colorFrom }, { background: colorTo }], {
        fill: "forwards",
        duration: milliseconds
    }
    );

}

export  function flickerOpacity(dom, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ opacity: "1" },{ opacity: "0" }, { opacity: "1" }], {
        fill: "forwards",
        duration: milliseconds
    }
    );

}

export  function pulseElemntRing(dom,ringWidth,colorFrom, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ outline: ringWidth+"px solid "+colorFrom }, { outline: ringWidth+"px solid transparent" }], {
        fill: "forwards",
        duration: milliseconds
    }
    );

}

export  function pulseElemntShadow(dom,colorFrom, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ boxShadow: "0px 0px 20px -6px"+colorFrom }, { boxShadow: "0px 0px 0px 0px transparent" }], {
        fill: "forwards",
        duration: milliseconds
    }
    );

}

export  function pulseUISelection(dom, milliseconds = 200) {

    if(dom!=null&&dom.animate!= null)
    dom.animate([{ outline: "1px solid var(--input-selected-primary)",background:"var(--input-selected-bg)" }, {outline: "1px solid transparent",background:"transparent"  }], {
        fill: "forwards",
        duration: milliseconds
    }
    );

}